import { useQuery } from 'react-query'
import { AppMode } from '@customTypes/Generic'
import { PatientTypeOptions } from 'src/config/patientTypeOptions'
import { getClinicsInCityForSelectedTreatment } from 'src/services/api/clinic'
import { useChoiceState } from '@context/ChoiceContext'
import { useConfig } from '@context/ConfigurationContext'
import useClinic from './useClinic'
import { useTreatmentPurpose } from './useTreatmentPurpose'

export const useCityClinicsForSelectedTreatment = () => {
  const { clinicId, mode } = useConfig()
  const { data: clinic } = useClinic(clinicId)
  const { patientType } = useChoiceState()
  const isNewPatient = patientType === PatientTypeOptions.NEW

  const treatmentPurposeReferenceId = useTreatmentPurpose()
  const cityName = clinic?.city

  const result = useQuery(
    ['clinicsForTreatmentInCity', cityName, treatmentPurposeReferenceId, clinic?.lat, clinic?.long, clinicId],
    () =>
      getClinicsInCityForSelectedTreatment(
        clinicId,
        treatmentPurposeReferenceId!,
        cityName!,
        undefined,
        clinic?.lat,
        clinic?.long
      ),
    {
      retry: 3,
      enabled: !!cityName && !!treatmentPurposeReferenceId && mode === AppMode.NORMAL && isNewPatient,
    }
  )

  return result
}
